import { isUndefinedNullOrEmpty } from '../utils';
import { licenceStatuses } from '../statuses';

const Licence = function(licenceStatus, description) {
    const self = this;

    if(isUndefinedNullOrEmpty(licenceStatus)) { throw 'licenceStatus is required'; }

    self.status = licenceStatus;
    self.description = description;
};

Licence.prototype.mayRun = function() {
    return this.status === licenceStatuses.trial || this.status === licenceStatuses.licensed;
};

export default Licence;


// WEBPACK FOOTER //
// ./src/js/models/Licence.js